export default __webpack_public_path__ + "static/business-save-e5ef40b23584c26299a6a62144c0c8cf.webp";